import { render, staticRenderFns } from "./FilterConfigurador.vue?vue&type=template&id=40a59cad"
import script from "./FilterConfigurador.vue?vue&type=script&lang=js"
export * from "./FilterConfigurador.vue?vue&type=script&lang=js"
import style0 from "./FilterConfigurador.vue?vue&type=style&index=0&id=40a59cad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports